"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * API Documentation
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RespondentApi = exports.RespondentApiFactory = exports.RespondentApiFp = exports.RespondentApiAxiosParamCreator = exports.AdminApi = exports.AdminApiFactory = exports.AdminApiFp = exports.AdminApiAxiosParamCreator = exports.VersionObjectEnum = exports.TokenObjectEnum = exports.TextFieldTypeEnum = exports.SubmissionStatus = exports.SubmissionObjectEnum = exports.StringFieldTypeEnum = exports.RespondentFormDefinitionObjectEnum = exports.NumberFieldTypeEnum = exports.NoteObjectEnum = exports.FormDefinitionStatus = exports.EnumFieldTypeEnum = exports.EmailFieldTypeEnum = exports.DateFieldTypeEnum = exports.BooleanFieldTypeEnum = exports.AdminVersionList200ResponseObjectEnum = exports.AdminSubmissionList200ResponseObjectEnum = exports.AdminNoteList200ResponseObjectEnum = exports.AdminFormDefinitionCreateRequestVariablesInnerOneOf1KindEnum = exports.AdminFormDefinitionCreateRequestVariablesInnerOneOfKindEnum = exports.AdminFormDefinitionCreateRequestFieldsInnerOneOf6TypeEnum = exports.AdminFormDefinitionCreateRequestFieldsInnerOneOf5TypeEnum = exports.AdminFormDefinitionCreateRequestFieldsInnerOneOf4TypeEnum = exports.AdminFormDefinitionCreateRequestFieldsInnerOneOf3TypeEnum = exports.AdminFormDefinitionCreateRequestFieldsInnerOneOf2TypeEnum = exports.AdminFormDefinitionCreateRequestFieldsInnerOneOf1TypeEnum = exports.AdminFormDefinitionCreateRequestFieldsInnerOneOfTypeEnum = exports.AdminFormDefinitionObjectEnum = exports.AdminDefinitionList200ResponseObjectEnum = void 0;
const axios_1 = __importDefault(require("axios"));
// Some imports not used depending on template conditions
// @ts-ignore
const common_1 = require("./common");
// @ts-ignore
const base_1 = require("./base");
exports.AdminDefinitionList200ResponseObjectEnum = {
    List: 'list'
};
exports.AdminFormDefinitionObjectEnum = {
    Definition: 'definition'
};
exports.AdminFormDefinitionCreateRequestFieldsInnerOneOfTypeEnum = {
    String: 'string'
};
exports.AdminFormDefinitionCreateRequestFieldsInnerOneOf1TypeEnum = {
    Number: 'number'
};
exports.AdminFormDefinitionCreateRequestFieldsInnerOneOf2TypeEnum = {
    Boolean: 'boolean'
};
exports.AdminFormDefinitionCreateRequestFieldsInnerOneOf3TypeEnum = {
    Text: 'text'
};
exports.AdminFormDefinitionCreateRequestFieldsInnerOneOf4TypeEnum = {
    Date: 'date'
};
exports.AdminFormDefinitionCreateRequestFieldsInnerOneOf5TypeEnum = {
    Enum: 'enum'
};
exports.AdminFormDefinitionCreateRequestFieldsInnerOneOf6TypeEnum = {
    Email: 'email'
};
exports.AdminFormDefinitionCreateRequestVariablesInnerOneOfKindEnum = {
    Score: 'score'
};
exports.AdminFormDefinitionCreateRequestVariablesInnerOneOf1KindEnum = {
    Tag: 'tag'
};
exports.AdminNoteList200ResponseObjectEnum = {
    List: 'list'
};
exports.AdminSubmissionList200ResponseObjectEnum = {
    List: 'list'
};
exports.AdminVersionList200ResponseObjectEnum = {
    List: 'list'
};
exports.BooleanFieldTypeEnum = {
    Boolean: 'boolean'
};
exports.DateFieldTypeEnum = {
    Date: 'date'
};
exports.EmailFieldTypeEnum = {
    Email: 'email'
};
exports.EnumFieldTypeEnum = {
    Enum: 'enum'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.FormDefinitionStatus = {
    Draft: 'draft',
    Published: 'published',
    Archived: 'archived'
};
exports.NoteObjectEnum = {
    Note: 'note'
};
exports.NumberFieldTypeEnum = {
    Number: 'number'
};
exports.RespondentFormDefinitionObjectEnum = {
    Definition: 'definition'
};
exports.StringFieldTypeEnum = {
    String: 'string'
};
exports.SubmissionObjectEnum = {
    Submission: 'submission'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.SubmissionStatus = {
    Draft: 'draft',
    Submitted: 'submitted',
    Archived: 'archived'
};
exports.TextFieldTypeEnum = {
    Text: 'text'
};
exports.TokenObjectEnum = {
    Token: 'token'
};
exports.VersionObjectEnum = {
    Version: 'version'
};
/**
 * AdminApi - axios parameter creator
 * @export
 */
const AdminApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary admin definition archive
         * @param {string} definitionId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDefinitionArchive: async (definitionId, options = {}) => {
            // verify required parameter 'definitionId' is not null or undefined
            (0, common_1.assertParamExists)('adminDefinitionArchive', 'definitionId', definitionId);
            const localVarPath = `/admin/definitions/{definitionId}/archive`
                .replace(`{${"definitionId"}}`, encodeURIComponent(String(definitionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary admin definition create
         * @param {AdminFormDefinitionCreateRequest} [adminFormDefinitionCreateRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDefinitionCreate: async (adminFormDefinitionCreateRequest, options = {}) => {
            const localVarPath = `/admin/definitions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(adminFormDefinitionCreateRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary admin definition list
         * @param {string} [slug]
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDefinitionList: async (slug, limit, options = {}) => {
            const localVarPath = `/admin/definitions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (slug !== undefined) {
                localVarQueryParameter['slug'] = slug;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary admin definition publish
         * @param {string} definitionId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDefinitionPublish: async (definitionId, options = {}) => {
            // verify required parameter 'definitionId' is not null or undefined
            (0, common_1.assertParamExists)('adminDefinitionPublish', 'definitionId', definitionId);
            const localVarPath = `/admin/definitions/{definitionId}/publish`
                .replace(`{${"definitionId"}}`, encodeURIComponent(String(definitionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary admin definition retrieve
         * @param {string} definitionId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDefinitionRetrieve: async (definitionId, options = {}) => {
            // verify required parameter 'definitionId' is not null or undefined
            (0, common_1.assertParamExists)('adminDefinitionRetrieve', 'definitionId', definitionId);
            const localVarPath = `/admin/definitions/{definitionId}`
                .replace(`{${"definitionId"}}`, encodeURIComponent(String(definitionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary admin note create
         * @param {NoteCreateRequest} [noteCreateRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminNoteCreate: async (noteCreateRequest, options = {}) => {
            const localVarPath = `/admin/notes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(noteCreateRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary admin note delete
         * @param {string} noteId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminNoteDelete: async (noteId, options = {}) => {
            // verify required parameter 'noteId' is not null or undefined
            (0, common_1.assertParamExists)('adminNoteDelete', 'noteId', noteId);
            const localVarPath = `/admin/notes/{noteId}`
                .replace(`{${"noteId"}}`, encodeURIComponent(String(noteId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary admin note list
         * @param {string} submission Submission ID
         * @param {number | null} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminNoteList: async (submission, limit, options = {}) => {
            // verify required parameter 'submission' is not null or undefined
            (0, common_1.assertParamExists)('adminNoteList', 'submission', submission);
            const localVarPath = `/admin/notes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (submission !== undefined) {
                localVarQueryParameter['submission'] = submission;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary admin note retrieve
         * @param {string} noteId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminNoteRetrieve: async (noteId, options = {}) => {
            // verify required parameter 'noteId' is not null or undefined
            (0, common_1.assertParamExists)('adminNoteRetrieve', 'noteId', noteId);
            const localVarPath = `/admin/notes/{noteId}`
                .replace(`{${"noteId"}}`, encodeURIComponent(String(noteId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary admin note update
         * @param {string} noteId
         * @param {NoteUpdateRequest} [noteUpdateRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminNoteUpdate: async (noteId, noteUpdateRequest, options = {}) => {
            // verify required parameter 'noteId' is not null or undefined
            (0, common_1.assertParamExists)('adminNoteUpdate', 'noteId', noteId);
            const localVarPath = `/admin/notes/{noteId}`
                .replace(`{${"noteId"}}`, encodeURIComponent(String(noteId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(noteUpdateRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary admin submission archive
         * @param {string} submissionId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminSubmissionArchive: async (submissionId, options = {}) => {
            // verify required parameter 'submissionId' is not null or undefined
            (0, common_1.assertParamExists)('adminSubmissionArchive', 'submissionId', submissionId);
            const localVarPath = `/admin/submissions/{submissionId}/archive`
                .replace(`{${"submissionId"}}`, encodeURIComponent(String(submissionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary admin submission create
         * @param {AdminSubmissionCreateRequest} [adminSubmissionCreateRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminSubmissionCreate: async (adminSubmissionCreateRequest, options = {}) => {
            const localVarPath = `/admin/submissions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(adminSubmissionCreateRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary admin submission delete
         * @param {string} submissionId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminSubmissionDelete: async (submissionId, options = {}) => {
            // verify required parameter 'submissionId' is not null or undefined
            (0, common_1.assertParamExists)('adminSubmissionDelete', 'submissionId', submissionId);
            const localVarPath = `/admin/submissions/{submissionId}`
                .replace(`{${"submissionId"}}`, encodeURIComponent(String(submissionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary admin submission list
         * @param {string} [form] Form slug
         * @param {SubmissionStatus} [status]
         * @param {number | null} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminSubmissionList: async (form, status, limit, options = {}) => {
            const localVarPath = `/admin/submissions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (form !== undefined) {
                localVarQueryParameter['form'] = form;
            }
            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary admin submission retrieve
         * @param {string} submissionId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminSubmissionRetrieve: async (submissionId, options = {}) => {
            // verify required parameter 'submissionId' is not null or undefined
            (0, common_1.assertParamExists)('adminSubmissionRetrieve', 'submissionId', submissionId);
            const localVarPath = `/admin/submissions/{submissionId}`
                .replace(`{${"submissionId"}}`, encodeURIComponent(String(submissionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary admin token create
         * @param {TokenCreateRequest} [tokenCreateRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminTokenCreate: async (tokenCreateRequest, options = {}) => {
            const localVarPath = `/admin/tokens`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(tokenCreateRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary admin version list
         * @param {string} definition
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminVersionList: async (definition, options = {}) => {
            // verify required parameter 'definition' is not null or undefined
            (0, common_1.assertParamExists)('adminVersionList', 'definition', definition);
            const localVarPath = `/admin/versions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (definition !== undefined) {
                localVarQueryParameter['definition'] = definition;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary admin version retrieve
         * @param {string} versionId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminVersionRetrieve: async (versionId, options = {}) => {
            // verify required parameter 'versionId' is not null or undefined
            (0, common_1.assertParamExists)('adminVersionRetrieve', 'versionId', versionId);
            const localVarPath = `/admin/versions/{versionId}`
                .replace(`{${"versionId"}}`, encodeURIComponent(String(versionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.AdminApiAxiosParamCreator = AdminApiAxiosParamCreator;
/**
 * AdminApi - functional programming interface
 * @export
 */
const AdminApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.AdminApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary admin definition archive
         * @param {string} definitionId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminDefinitionArchive(definitionId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminDefinitionArchive(definitionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['AdminApi.adminDefinitionArchive']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary admin definition create
         * @param {AdminFormDefinitionCreateRequest} [adminFormDefinitionCreateRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminDefinitionCreate(adminFormDefinitionCreateRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminDefinitionCreate(adminFormDefinitionCreateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['AdminApi.adminDefinitionCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary admin definition list
         * @param {string} [slug]
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminDefinitionList(slug, limit, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminDefinitionList(slug, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['AdminApi.adminDefinitionList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary admin definition publish
         * @param {string} definitionId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminDefinitionPublish(definitionId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminDefinitionPublish(definitionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['AdminApi.adminDefinitionPublish']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary admin definition retrieve
         * @param {string} definitionId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminDefinitionRetrieve(definitionId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminDefinitionRetrieve(definitionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['AdminApi.adminDefinitionRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary admin note create
         * @param {NoteCreateRequest} [noteCreateRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminNoteCreate(noteCreateRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminNoteCreate(noteCreateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['AdminApi.adminNoteCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary admin note delete
         * @param {string} noteId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminNoteDelete(noteId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminNoteDelete(noteId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['AdminApi.adminNoteDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary admin note list
         * @param {string} submission Submission ID
         * @param {number | null} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminNoteList(submission, limit, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminNoteList(submission, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['AdminApi.adminNoteList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary admin note retrieve
         * @param {string} noteId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminNoteRetrieve(noteId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminNoteRetrieve(noteId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['AdminApi.adminNoteRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary admin note update
         * @param {string} noteId
         * @param {NoteUpdateRequest} [noteUpdateRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminNoteUpdate(noteId, noteUpdateRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminNoteUpdate(noteId, noteUpdateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['AdminApi.adminNoteUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary admin submission archive
         * @param {string} submissionId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminSubmissionArchive(submissionId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminSubmissionArchive(submissionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['AdminApi.adminSubmissionArchive']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary admin submission create
         * @param {AdminSubmissionCreateRequest} [adminSubmissionCreateRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminSubmissionCreate(adminSubmissionCreateRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminSubmissionCreate(adminSubmissionCreateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['AdminApi.adminSubmissionCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary admin submission delete
         * @param {string} submissionId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminSubmissionDelete(submissionId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminSubmissionDelete(submissionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['AdminApi.adminSubmissionDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary admin submission list
         * @param {string} [form] Form slug
         * @param {SubmissionStatus} [status]
         * @param {number | null} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminSubmissionList(form, status, limit, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminSubmissionList(form, status, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['AdminApi.adminSubmissionList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary admin submission retrieve
         * @param {string} submissionId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminSubmissionRetrieve(submissionId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminSubmissionRetrieve(submissionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['AdminApi.adminSubmissionRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary admin token create
         * @param {TokenCreateRequest} [tokenCreateRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminTokenCreate(tokenCreateRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminTokenCreate(tokenCreateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['AdminApi.adminTokenCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary admin version list
         * @param {string} definition
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminVersionList(definition, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminVersionList(definition, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['AdminApi.adminVersionList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary admin version retrieve
         * @param {string} versionId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminVersionRetrieve(versionId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminVersionRetrieve(versionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['AdminApi.adminVersionRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
exports.AdminApiFp = AdminApiFp;
/**
 * AdminApi - factory interface
 * @export
 */
const AdminApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.AdminApiFp)(configuration);
    return {
        /**
         *
         * @summary admin definition archive
         * @param {AdminApiAdminDefinitionArchiveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDefinitionArchive(requestParameters, options) {
            return localVarFp.adminDefinitionArchive(requestParameters.definitionId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary admin definition create
         * @param {AdminApiAdminDefinitionCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDefinitionCreate(requestParameters = {}, options) {
            return localVarFp.adminDefinitionCreate(requestParameters.adminFormDefinitionCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary admin definition list
         * @param {AdminApiAdminDefinitionListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDefinitionList(requestParameters = {}, options) {
            return localVarFp.adminDefinitionList(requestParameters.slug, requestParameters.limit, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary admin definition publish
         * @param {AdminApiAdminDefinitionPublishRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDefinitionPublish(requestParameters, options) {
            return localVarFp.adminDefinitionPublish(requestParameters.definitionId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary admin definition retrieve
         * @param {AdminApiAdminDefinitionRetrieveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDefinitionRetrieve(requestParameters, options) {
            return localVarFp.adminDefinitionRetrieve(requestParameters.definitionId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary admin note create
         * @param {AdminApiAdminNoteCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminNoteCreate(requestParameters = {}, options) {
            return localVarFp.adminNoteCreate(requestParameters.noteCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary admin note delete
         * @param {AdminApiAdminNoteDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminNoteDelete(requestParameters, options) {
            return localVarFp.adminNoteDelete(requestParameters.noteId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary admin note list
         * @param {AdminApiAdminNoteListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminNoteList(requestParameters, options) {
            return localVarFp.adminNoteList(requestParameters.submission, requestParameters.limit, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary admin note retrieve
         * @param {AdminApiAdminNoteRetrieveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminNoteRetrieve(requestParameters, options) {
            return localVarFp.adminNoteRetrieve(requestParameters.noteId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary admin note update
         * @param {AdminApiAdminNoteUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminNoteUpdate(requestParameters, options) {
            return localVarFp.adminNoteUpdate(requestParameters.noteId, requestParameters.noteUpdateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary admin submission archive
         * @param {AdminApiAdminSubmissionArchiveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminSubmissionArchive(requestParameters, options) {
            return localVarFp.adminSubmissionArchive(requestParameters.submissionId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary admin submission create
         * @param {AdminApiAdminSubmissionCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminSubmissionCreate(requestParameters = {}, options) {
            return localVarFp.adminSubmissionCreate(requestParameters.adminSubmissionCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary admin submission delete
         * @param {AdminApiAdminSubmissionDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminSubmissionDelete(requestParameters, options) {
            return localVarFp.adminSubmissionDelete(requestParameters.submissionId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary admin submission list
         * @param {AdminApiAdminSubmissionListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminSubmissionList(requestParameters = {}, options) {
            return localVarFp.adminSubmissionList(requestParameters.form, requestParameters.status, requestParameters.limit, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary admin submission retrieve
         * @param {AdminApiAdminSubmissionRetrieveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminSubmissionRetrieve(requestParameters, options) {
            return localVarFp.adminSubmissionRetrieve(requestParameters.submissionId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary admin token create
         * @param {AdminApiAdminTokenCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminTokenCreate(requestParameters = {}, options) {
            return localVarFp.adminTokenCreate(requestParameters.tokenCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary admin version list
         * @param {AdminApiAdminVersionListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminVersionList(requestParameters, options) {
            return localVarFp.adminVersionList(requestParameters.definition, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary admin version retrieve
         * @param {AdminApiAdminVersionRetrieveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminVersionRetrieve(requestParameters, options) {
            return localVarFp.adminVersionRetrieve(requestParameters.versionId, options).then((request) => request(axios, basePath));
        },
    };
};
exports.AdminApiFactory = AdminApiFactory;
/**
 * AdminApi - object-oriented interface
 * @export
 * @class AdminApi
 * @extends {BaseAPI}
 */
class AdminApi extends base_1.BaseAPI {
    /**
     *
     * @summary admin definition archive
     * @param {AdminApiAdminDefinitionArchiveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    adminDefinitionArchive(requestParameters, options) {
        return (0, exports.AdminApiFp)(this.configuration).adminDefinitionArchive(requestParameters.definitionId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary admin definition create
     * @param {AdminApiAdminDefinitionCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    adminDefinitionCreate(requestParameters = {}, options) {
        return (0, exports.AdminApiFp)(this.configuration).adminDefinitionCreate(requestParameters.adminFormDefinitionCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary admin definition list
     * @param {AdminApiAdminDefinitionListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    adminDefinitionList(requestParameters = {}, options) {
        return (0, exports.AdminApiFp)(this.configuration).adminDefinitionList(requestParameters.slug, requestParameters.limit, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary admin definition publish
     * @param {AdminApiAdminDefinitionPublishRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    adminDefinitionPublish(requestParameters, options) {
        return (0, exports.AdminApiFp)(this.configuration).adminDefinitionPublish(requestParameters.definitionId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary admin definition retrieve
     * @param {AdminApiAdminDefinitionRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    adminDefinitionRetrieve(requestParameters, options) {
        return (0, exports.AdminApiFp)(this.configuration).adminDefinitionRetrieve(requestParameters.definitionId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary admin note create
     * @param {AdminApiAdminNoteCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    adminNoteCreate(requestParameters = {}, options) {
        return (0, exports.AdminApiFp)(this.configuration).adminNoteCreate(requestParameters.noteCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary admin note delete
     * @param {AdminApiAdminNoteDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    adminNoteDelete(requestParameters, options) {
        return (0, exports.AdminApiFp)(this.configuration).adminNoteDelete(requestParameters.noteId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary admin note list
     * @param {AdminApiAdminNoteListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    adminNoteList(requestParameters, options) {
        return (0, exports.AdminApiFp)(this.configuration).adminNoteList(requestParameters.submission, requestParameters.limit, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary admin note retrieve
     * @param {AdminApiAdminNoteRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    adminNoteRetrieve(requestParameters, options) {
        return (0, exports.AdminApiFp)(this.configuration).adminNoteRetrieve(requestParameters.noteId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary admin note update
     * @param {AdminApiAdminNoteUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    adminNoteUpdate(requestParameters, options) {
        return (0, exports.AdminApiFp)(this.configuration).adminNoteUpdate(requestParameters.noteId, requestParameters.noteUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary admin submission archive
     * @param {AdminApiAdminSubmissionArchiveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    adminSubmissionArchive(requestParameters, options) {
        return (0, exports.AdminApiFp)(this.configuration).adminSubmissionArchive(requestParameters.submissionId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary admin submission create
     * @param {AdminApiAdminSubmissionCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    adminSubmissionCreate(requestParameters = {}, options) {
        return (0, exports.AdminApiFp)(this.configuration).adminSubmissionCreate(requestParameters.adminSubmissionCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary admin submission delete
     * @param {AdminApiAdminSubmissionDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    adminSubmissionDelete(requestParameters, options) {
        return (0, exports.AdminApiFp)(this.configuration).adminSubmissionDelete(requestParameters.submissionId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary admin submission list
     * @param {AdminApiAdminSubmissionListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    adminSubmissionList(requestParameters = {}, options) {
        return (0, exports.AdminApiFp)(this.configuration).adminSubmissionList(requestParameters.form, requestParameters.status, requestParameters.limit, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary admin submission retrieve
     * @param {AdminApiAdminSubmissionRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    adminSubmissionRetrieve(requestParameters, options) {
        return (0, exports.AdminApiFp)(this.configuration).adminSubmissionRetrieve(requestParameters.submissionId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary admin token create
     * @param {AdminApiAdminTokenCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    adminTokenCreate(requestParameters = {}, options) {
        return (0, exports.AdminApiFp)(this.configuration).adminTokenCreate(requestParameters.tokenCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary admin version list
     * @param {AdminApiAdminVersionListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    adminVersionList(requestParameters, options) {
        return (0, exports.AdminApiFp)(this.configuration).adminVersionList(requestParameters.definition, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary admin version retrieve
     * @param {AdminApiAdminVersionRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    adminVersionRetrieve(requestParameters, options) {
        return (0, exports.AdminApiFp)(this.configuration).adminVersionRetrieve(requestParameters.versionId, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.AdminApi = AdminApi;
/**
 * RespondentApi - axios parameter creator
 * @export
 */
const RespondentApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary respondent definition retrieve
         * @param {string} definitionIdOrSlug
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        respondentDefinitionRetrieve: async (definitionIdOrSlug, options = {}) => {
            // verify required parameter 'definitionIdOrSlug' is not null or undefined
            (0, common_1.assertParamExists)('respondentDefinitionRetrieve', 'definitionIdOrSlug', definitionIdOrSlug);
            const localVarPath = `/definitions/{definitionIdOrSlug}`
                .replace(`{${"definitionIdOrSlug"}}`, encodeURIComponent(String(definitionIdOrSlug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary respondent submission create
         * @param {boolean | null} [dryrun]
         * @param {SubmissionCreateRequest} [submissionCreateRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        respondentSubmissionCreate: async (dryrun, submissionCreateRequest, options = {}) => {
            const localVarPath = `/respondent/submissions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (dryrun !== undefined) {
                localVarQueryParameter['dryrun'] = dryrun;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(submissionCreateRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary respondent submission list
         * @param {string} [form] Form slug
         * @param {SubmissionStatus} [status]
         * @param {number | null} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        respondentSubmissionList: async (form, status, limit, options = {}) => {
            const localVarPath = `/respondent/submissions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (form !== undefined) {
                localVarQueryParameter['form'] = form;
            }
            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary respondent submission retrieve
         * @param {string} submissionId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        respondentSubmissionRetrieve: async (submissionId, options = {}) => {
            // verify required parameter 'submissionId' is not null or undefined
            (0, common_1.assertParamExists)('respondentSubmissionRetrieve', 'submissionId', submissionId);
            const localVarPath = `/respondent/submissions/{submissionId}`
                .replace(`{${"submissionId"}}`, encodeURIComponent(String(submissionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.RespondentApiAxiosParamCreator = RespondentApiAxiosParamCreator;
/**
 * RespondentApi - functional programming interface
 * @export
 */
const RespondentApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.RespondentApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary respondent definition retrieve
         * @param {string} definitionIdOrSlug
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async respondentDefinitionRetrieve(definitionIdOrSlug, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.respondentDefinitionRetrieve(definitionIdOrSlug, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['RespondentApi.respondentDefinitionRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary respondent submission create
         * @param {boolean | null} [dryrun]
         * @param {SubmissionCreateRequest} [submissionCreateRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async respondentSubmissionCreate(dryrun, submissionCreateRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.respondentSubmissionCreate(dryrun, submissionCreateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['RespondentApi.respondentSubmissionCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary respondent submission list
         * @param {string} [form] Form slug
         * @param {SubmissionStatus} [status]
         * @param {number | null} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async respondentSubmissionList(form, status, limit, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.respondentSubmissionList(form, status, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['RespondentApi.respondentSubmissionList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary respondent submission retrieve
         * @param {string} submissionId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async respondentSubmissionRetrieve(submissionId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.respondentSubmissionRetrieve(submissionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['RespondentApi.respondentSubmissionRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
exports.RespondentApiFp = RespondentApiFp;
/**
 * RespondentApi - factory interface
 * @export
 */
const RespondentApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.RespondentApiFp)(configuration);
    return {
        /**
         *
         * @summary respondent definition retrieve
         * @param {RespondentApiRespondentDefinitionRetrieveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        respondentDefinitionRetrieve(requestParameters, options) {
            return localVarFp.respondentDefinitionRetrieve(requestParameters.definitionIdOrSlug, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary respondent submission create
         * @param {RespondentApiRespondentSubmissionCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        respondentSubmissionCreate(requestParameters = {}, options) {
            return localVarFp.respondentSubmissionCreate(requestParameters.dryrun, requestParameters.submissionCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary respondent submission list
         * @param {RespondentApiRespondentSubmissionListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        respondentSubmissionList(requestParameters = {}, options) {
            return localVarFp.respondentSubmissionList(requestParameters.form, requestParameters.status, requestParameters.limit, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary respondent submission retrieve
         * @param {RespondentApiRespondentSubmissionRetrieveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        respondentSubmissionRetrieve(requestParameters, options) {
            return localVarFp.respondentSubmissionRetrieve(requestParameters.submissionId, options).then((request) => request(axios, basePath));
        },
    };
};
exports.RespondentApiFactory = RespondentApiFactory;
/**
 * RespondentApi - object-oriented interface
 * @export
 * @class RespondentApi
 * @extends {BaseAPI}
 */
class RespondentApi extends base_1.BaseAPI {
    /**
     *
     * @summary respondent definition retrieve
     * @param {RespondentApiRespondentDefinitionRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RespondentApi
     */
    respondentDefinitionRetrieve(requestParameters, options) {
        return (0, exports.RespondentApiFp)(this.configuration).respondentDefinitionRetrieve(requestParameters.definitionIdOrSlug, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary respondent submission create
     * @param {RespondentApiRespondentSubmissionCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RespondentApi
     */
    respondentSubmissionCreate(requestParameters = {}, options) {
        return (0, exports.RespondentApiFp)(this.configuration).respondentSubmissionCreate(requestParameters.dryrun, requestParameters.submissionCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary respondent submission list
     * @param {RespondentApiRespondentSubmissionListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RespondentApi
     */
    respondentSubmissionList(requestParameters = {}, options) {
        return (0, exports.RespondentApiFp)(this.configuration).respondentSubmissionList(requestParameters.form, requestParameters.status, requestParameters.limit, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary respondent submission retrieve
     * @param {RespondentApiRespondentSubmissionRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RespondentApi
     */
    respondentSubmissionRetrieve(requestParameters, options) {
        return (0, exports.RespondentApiFp)(this.configuration).respondentSubmissionRetrieve(requestParameters.submissionId, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.RespondentApi = RespondentApi;
//# sourceMappingURL=api.js.map